import { useTranslation } from "../../state/i18n.tsx";
import { useAuthDispatch } from "../../state/auth.tsx";
import SignupLayout from "./SignupLayout.tsx";
import moreappIconBrand from "../../assets/moreapp-icon-brand.svg";
import Text from "../../components/text/Text.tsx";
import { Translation } from "../../utils/Translation.tsx";
import { keyFromSelector } from "i18next";
import TextLink from "../../components/link/TextLink.tsx";
import { TextButton } from "../../components/button/Button.tsx";

export const ValidationFailed = () => {
  const { t } = useTranslation();
  const { login } = useAuthDispatch();

  return (
    <SignupLayout>
      <div class="flex flex-col gap-20">
        <div class="flex flex-col items-center gap-10 desktop:items-start">
          <img src={moreappIconBrand} class="size-12" alt={t(($) => $.MOREAPP_LOGO_IMG_ALT)} />
          <div class="flex flex-col gap-6">
            <div class="flex flex-col gap-1 text-center desktop:text-left">
              <Text as="h1" class="text-header-3xl text-primary" text={t(($) => $.EMAIL_VALIDATION_FAILED_TITLE)} />
              <div class="flex flex-col gap-4">
                <Text class="text-medium-regular text-secondary" text={t(($) => $.EMAIL_VALIDATION_FAILED_SUBTITLE)} />
                <span class="text-medium-regular text-secondary">
                  <Translation
                    key={keyFromSelector(($) => $.EMAIL_VALIDATION_FAILED_CONTACT_SUPPORT)}
                    components={{
                      externalLink: (props) => <TextLink isExternal href={props.href} label={props.label} />,
                    }}
                  />
                </span>
              </div>
            </div>
            <TextButton class="w-full" onClick={() => login()} text={t(($) => $.EMAIL_VALIDATION_FAILED_LOGIN)} />
          </div>
        </div>
      </div>
    </SignupLayout>
  );
};
